export const US_PHONE_NUMBER_DIGIT_LIMIT = 10;

export const US_PHONE_NUMBER_WITH_COUNTRY_CODE_DISPLAY_LENGTH = 17;

/**
 * Extracts US phone digits without truncating.
 * Strips a leading +1 display prefix and a leading US country code when present.
 */
export const extractUsPhoneDigits = (phoneNumber: string): string => {
  let input = phoneNumber.trim();

  if (input.startsWith('+1')) {
    input = input.slice(2);
  }

  let digits = input.replace(/\D/g, '');

  if (digits.length > US_PHONE_NUMBER_DIGIT_LIMIT && digits.startsWith('1')) {
    digits = digits.slice(1);
  }

  return digits;
};

/**
 * Parses a phone number to US digits only (max 10 digits).
 * Strips a leading +1 display prefix and US country code when present.
 */
export const parsePhoneNumber = (phoneNumber: string): string => {
  return extractUsPhoneDigits(phoneNumber).slice(
    0,
    US_PHONE_NUMBER_DIGIT_LIMIT,
  );
};

export const isValidUsPhoneDigitCount = (phoneNumber: string): boolean => {
  const trimmed = phoneNumber.trim();
  if (!trimmed) return true;

  return (
    extractUsPhoneDigits(phoneNumber).length === US_PHONE_NUMBER_DIGIT_LIMIT
  );
};

/**
 * Formats a phone number string to (123) 456-7890
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  const digits = parsePhoneNumber(phoneNumber);

  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, US_PHONE_NUMBER_DIGIT_LIMIT)}`;
};

/**
 * Formats a phone number for display as +1 (234) 567-8901
 */
export const formatUsPhoneNumberWithCountryCode = (
  phoneNumber: string,
): string => {
  const formatted = formatPhoneNumber(phoneNumber);

  if (!formatted) return '';

  return `+1 ${formatted}`;
};
